import { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface TourContextType {
  runTour: boolean;
  startTour: () => void;
  stopTour: () => void;
}

const TourContext = createContext<TourContextType>({
  runTour: false,
  startTour: () => {},
  stopTour: () => {}
});

export const useTour = () => useContext(TourContext);

interface TourProviderProps {
  children: ReactNode;
}

export function TourProvider({ children }: TourProviderProps) {
  const [runTour, setRunTour] = useState(false);

  const startTour = useCallback(() => setRunTour(true), []);
  const stopTour = useCallback(() => setRunTour(false), []);

  return (
    <TourContext.Provider value={{ runTour, startTour, stopTour }}>
      {children}
    </TourContext.Provider>
  );
}
